import styled from 'styled-components';
export var DropdownWrapper = styled.div.withConfig({
  displayName: "RowsPerPagestyles__DropdownWrapper",
  componentId: "keen-widget-settings__sc-15au1ee-0"
})(["&&&{position:absolute;top:", "px;left:", "px;min-width:152px;}"], function (props) {
  return props.y;
}, function (props) {
  return props.x;
});
export var DroppableContainerWrapper = styled.div.withConfig({
  displayName: "RowsPerPagestyles__DroppableContainerWrapper",
  componentId: "keen-widget-settings__sc-15au1ee-1"
})(["&&&{min-width:152px;}"]);
export var RowsPerPageWrapper = styled.div.withConfig({
  displayName: "RowsPerPagestyles__RowsPerPageWrapper",
  componentId: "keen-widget-settings__sc-15au1ee-2"
})(["&&&{height:50px;}"]);